import { Box, Button, Card, Modal, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import { getSumsubStatusReq, getSumsubTokenRequest } from "../../../utils/apis/user";
import SumsubWebSdk from "@sumsub/websdk-react";
import { returnErrors } from "../../../store/reducers/error";

const SumsubModal = ({ open, sumHandleClose, kycStatus, getSumsubStatus, setOpen, setButtonLoading }) => {
  const [accessToken, setAccessToken] = useState("");
  const [loading, setLoading] = useState(true);
  const { idToken } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const getAccessToken = async () => {
    setLoading(true);
    try {
      const response = await getSumsubTokenRequest(idToken);
      if (response?.status === 200) {
        setAccessToken(response.data.token);
      }
    } catch (error) {
      setOpen(false);
      if (setButtonLoading) setButtonLoading(false);
      dispatch(returnErrors(error?.response?.data?.detail || "Something went wrong", 400));
    } finally {
      setLoading(false);
      if (setButtonLoading) setButtonLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      getAccessToken();
    }
    getSumsubStatus();
  }, [open]);

  const accessTokenExpirationHandler = (args) => {
    getAccessToken();
    getSumsubStatus();
  };
  const messageHandler = (message) => {
    // dispatch(getSumsubApplicantStatus()).then((res) => {
    //   dispatch(getPayoutVerificationStatus());
    // });

    if (message === "idCheck.applicantReviewComplete") {
      // KYC Approved
    }
  };

  const errorHandler = (args) => { };

  return (
    <Modal
      open={open && !loading}
      onClose={sumHandleClose}
      className="Modal"
    >
      <Box
        className="Modal-parent"
        gap={1}
        width={{ xs: "80%", md: "40%" }}
        margin="auto"
        marginTop="10%"
      >
        <Card
          className="Modal-card"
          variant="outlined"
        >
          <div className="sumsubModalWrapper">
            <h1>Sumsub Verification</h1>
            {accessToken ? (
              <SumsubWebSdk
                style={{ width: "100%" }}
                className="sumsub_modal"
                accessToken={accessToken}
                expirationHandler={accessTokenExpirationHandler}
                // config={config}
                // options={options}
                onMessage={messageHandler}
                onError={errorHandler}
              />
            ) : (
              false
            )}
            <button
              variant="outlined"
              size="medium"
              onClick={sumHandleClose}
              style={{ marginTop: "20px" }}
            >
              Close
            </button>
          </div>
        </Card>
      </Box>
    </Modal>
  );
};

export default SumsubModal;
